export default __webpack_public_path__ + "static/media/10.92b50e32.jpg";